import { LOGS } from 'constants/api';
import axios from 'utils/axios';

export const getLogs = async (data) => {
    const result = await axios.get(LOGS.v2.fetchLogs, {
        params: data
    });
    return result.data;
};
